export default __webpack_public_path__ + "static/media/eth.fa87a47e.svg";